import {
  API_BASE,
  DECOODA_API_BASE,
  DIAGNOSTICS_API_BASE,
  PROJECT_IQ_API_BASE,
} from "config";

const READ_ONLY_METHODS = new Set(["GET", "HEAD", "OPTIONS"]);
const WORKSPACES_URL_PREFIX = `${PROJECT_IQ_API_BASE}/workspaces/`;
const CONVERSATIONS_URL_PREFIX = `${API_BASE}/conversations/`;

type ProjectIqActivityListener = () => void;

const listeners = new Set<ProjectIqActivityListener>();

export const subscribeToProjectIqActivity = (
  listener: ProjectIqActivityListener,
): (() => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

// Workspace sub-resources whose writes the backend records as workspace activity.
const WORKSPACE_ACTIVITY_PATH_SEGMENTS = [
  "/analytics/",
  "/quality-review/",
  "/retrospective/",
  "/client-users/",
  "/folders/",
];
// Requested with POST but only to read, so they change nothing.
const READ_ONLY_PATH_SEGMENT = "/download-url/";

const isWorkspaceActivityUrl = (url: string): boolean =>
  url.startsWith(WORKSPACES_URL_PREFIX) &&
  !url.includes(READ_ONLY_PATH_SEGMENT) &&
  WORKSPACE_ACTIVITY_PATH_SEGMENTS.some((segment) => url.includes(segment));

const isChatMessageUrl = (url: string): boolean =>
  url.startsWith(CONVERSATIONS_URL_PREFIX) && url.includes("/messages/");

// Diagnostics, AI Analytics projects, chat messages and the quality review and
// retrospective files change the workspace, and the backend records that against it.
// Any successful write to them therefore means the workspace list is stale.
export const notifyIfProjectIqActivity = (
  url: string,
  method: string | undefined,
): void => {
  if (READ_ONLY_METHODS.has((method ?? "GET").toUpperCase())) return;
  const isProjectIqActivity =
    url.startsWith(DIAGNOSTICS_API_BASE) ||
    url.startsWith(DECOODA_API_BASE) ||
    isWorkspaceActivityUrl(url) ||
    isChatMessageUrl(url);
  if (!isProjectIqActivity) return;
  listeners.forEach((listener) => listener());
};
